// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3QG7L","col":"Table_col__9DFz3","fulfillmentStatus":"Table_fulfillmentStatus__3udyl","emailCol":"Table_emailCol__1AC5M"};